// import React from 'react'
// import { Navigate, useLocation } from 'react-router-dom';
// import { ROLE_ROUTES } from './RoleRoutes';
// import PropTypes from 'prop-types';

// const ProtectedRoute = ({ children, allowed, userRole }) => {
//     const location = useLocation();
//     const path = location.pathname.split('/')[1]; // Get first part of the route

//     if (ROLE_ROUTES[userRole]?.includes(path)) {
//         return children;
//     } else {
//         return <Navigate to="/customers" replace />;
//     }
// }

// ProtectedRoute.propTypes = {
//     children: PropTypes.any.isRequired,
//     userRole: PropTypes.string.isRequired,
//     allowed:PropTypes.any
// }

// export default ProtectedRoute

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ROLE_ROUTES } from './RoleRoutes';

const ProtectedRoute = () => {
  const location = useLocation();
  // const apiToken = localStorage.getItem("apiToken");
  // const userRole = apiToken ? JSON.parse(apiToken).userRole : "";

  const apiToken = JSON.parse(localStorage.getItem('apiToken') || '{}');

  const userRole = apiToken?.userRole || '';
  const associateStatus = apiToken?.associateStatus || apiToken?.userType;
  const referralCode = apiToken?.webAlias?.[0]?.alias;

  // BLOCK preenroll users
  if (associateStatus?.toLowerCase() === 'preenroll') {
    const baseUrl =
      process.env.REACT_APP_PRE_ENROLL_REDIRECT_URL || 'https://joinnoa.io/';
    if (referralCode) {
      return <Navigate to={`${baseUrl}${referralCode}/enrollment-kit`} replace />;
    } else {
      return (
        <Navigate
          to='/login'
          state={{
            message: 'Access denied — complete enrollment to access your dashboard.',
          }}
          replace
        />
      );
    }
  }

  // Get the top-level route path (e.g., 'settings' from '/settings/users')
  const topLevelRoute = location.pathname.split('/')[1];
  //   console.log(topLevelRoute,'route');

  // Get allowed routes for the userRole
  const allowedRoutes = ROLE_ROUTES[userRole] || [];

  // Allow if route is whitelisted
  if (allowedRoutes.includes(topLevelRoute)) {
    return <Outlet />;
  }

  return <Navigate to='/customers' replace />;
};

export default ProtectedRoute;
